// Analytics runtime configuration + shared types. Small, deliberately.

export type AnalyticsArea =
  | 'Chart Queue'
  | 'Chart Details'
  | 'History'
  | 'Notes'
  | 'Charts Dashboard'
  | 'Analytics Dashboard'
  | 'Knowledge Base'
  | 'Mandatory Fields'
  | 'Clients'
  | 'Access Requests'
  | 'Announcements'
  | 'Global Search'
  | 'System Admin'
  | 'Operations Dashboard'
  | 'Prompt Library'
  | 'Client Config'
  | 'Settings'
  | 'Notifications'
  | 'Other'

export type AnalyticsPrimitive = string | number | boolean
export type AnalyticsProps = Record<string, AnalyticsPrimitive>

export const ANALYTICS_CONFIG = {
  /** Path appended to the axios baseURL (already `/api/v1/app`). */
  ENDPOINT: '/analytics/events',
  /** How often the background flush timer runs. */
  FLUSH_INTERVAL_MS: 15_000,
  /** Max events in a single POST body. Server also enforces (Zod). */
  BATCH_MAX: 50,
  /**
   * Max events held in memory before FIFO-drop kicks in. 500 covers ~15 min
   * of very heavy use, or an offline stretch. Beyond that we prefer to lose
   * old events (already summarised in aggregates) than starve newer ones.
   */
  QUEUE_MAX: 500,
  /** Backup key so a hard reload doesn't lose the last ~30 s of events. */
  SESSION_STORAGE_KEY: 'medicodio.analytics.queue',
  MAX_PROPS_BYTES: 4_096,
} as const

/** UUID pattern used by path-normalise + a defence-in-depth strip in props. */
export const UUID_RE =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi
